import React from 'react';
import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '@/data/content';
import { Clock, ArrowUpRight } from 'lucide-react';

function BlogCard({ post, featured }) {
  return (
    <Link
      to={`/resources/blog/${post.slug}`}
      className={`group rounded-2xl border border-white/10 overflow-hidden bg-white/[0.02] hover:border-cyan-400/30 transition-all ${featured ? 'md:col-span-2' : ''}`}
    >
      <div className={`relative overflow-hidden ${featured ? 'aspect-[21/9]' : 'aspect-[16/9]'}`}>
        <img
          src={post.image}
          alt={post.title}
          onError={(e) => { e.currentTarget.src = post.fallback; }}
          className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#07090c]/80 via-transparent to-transparent" />
      </div>
      <div className="p-6">
        <div className="flex items-center gap-3 text-[10px] font-mono uppercase tracking-widest">
          <span className="text-cyan-300">{post.category}</span>
          <span className="text-slate-600">•</span>
          <span className="text-slate-500 flex items-center gap-1"><Clock className="w-3 h-3" />{post.readTime}</span>
        </div>
        <h3 className={`font-display font-bold mt-3 leading-tight text-slate-100 group-hover:text-cyan-300 transition-colors ${featured ? 'text-2xl md:text-3xl' : 'text-lg md:text-xl'}`}>
          {post.title}
        </h3>
        <p className="text-sm text-slate-400 mt-3 leading-relaxed line-clamp-3">
          {post.summary}
        </p>
        <div className="mt-4 inline-flex items-center gap-1 text-xs text-cyan-300 group-hover:gap-2 transition-all">
          Read article <ArrowUpRight className="w-3.5 h-3.5" />
        </div>
      </div>
    </Link>
  );
}

export default function BlogListPage() {
  const [featured, ...rest] = BLOG_POSTS;
  return (
    <div>
      <section className="relative py-20 md:py-28 border-b border-white/5 overflow-hidden">
        <div className="absolute inset-0 viso-grid opacity-40" />
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-xs font-mono uppercase tracking-[0.35em] text-cyan-300 mb-4">Resources · Blog</div>
          <h1 className="font-display text-4xl md:text-6xl font-bold max-w-4xl leading-[1.05]">
            <span className="text-gradient">Engineering &amp; product notes.</span>
          </h1>
          <p className="text-slate-400 mt-5 max-w-2xl">
            Field notes on AI vision for logistics — damage detection, gate automation, yard management and document processing.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-5">
            <BlogCard post={featured} featured />
            {rest.map((p) => (
              <BlogCard key={p.slug} post={p} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
